import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: '15px'
    },
    bold: {
      fontWeight: 700
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
